import { makeStyles } from '@material-ui/core';
import { MDSIcon, MDSTypography } from '@marqvision/mds-v2';

const useStyles = makeStyles(() => ({
  containerLayout: {
    height: '100%',
    placeContent: 'center',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
  },
  titleLayout: {
    marginTop: '16px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '32px',
  },
}));

export const ClientViewLoginErrorView = () => {
  const classes = useStyles();

  return (
    <div className={classes.containerLayout}>
      <MDSIcon.Info variant="border" color="color/content/neutral/default/disabled" size={80} />
      <div className={classes.titleLayout}>
        <MDSTypography
          variant="title"
          size="2xl"
          weight="semibold"
          color="color/content/neutral/tertiary/normal"
          style={{ fontSize: '40px' }}
        >
          Failed to load page
        </MDSTypography>
        <MDSTypography variant="body" size="m" weight="regular">
          Please close this window and try again.
        </MDSTypography>
      </div>
    </div>
  );
};
